import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 24 24";
const TabletIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.5 0C1.119 0 0 1.119 0 2.5V19.502C0 20.447 0.651172 21.262 1.57617 21.457C2.82517 21.721 4.89297 22 8.04297 22C11.166 22 13.1997 21.7258 14.4297 21.4648C15.3507 21.2688 16 20.4518 16 19.5098V2.5C16 1.119 14.881 0 13.5 0H2.5ZM2.5 3H13.5C13.776 3 14 3.224 14 3.5V16.5C14 16.776 13.776 17 13.5 17H2.5C2.224 17 2 16.776 2 16.5V3.5C2 3.224 2.224 3 2.5 3ZM5 5C4.448 5 4 5.448 4 6C4 6.552 4.448 7 5 7H11C11.552 7 12 6.552 12 6C12 5.448 11.552 5 11 5H5ZM5 9C4.448 9 4 9.448 4 10C4 10.552 4.448 11 5 11H8C8.552 11 9 10.552 9 10C9 9.448 8.552 9 8 9H5ZM5 13C4.448 13 4 13.448 4 14C4 14.552 4.448 15 5 15H11C11.552 15 12 14.552 12 14C12 13.448 11.552 13 11 13H5ZM8 17.875C8.622 17.875 9.125 18.378 9.125 19C9.125 19.622 8.622 20.125 8 20.125C7.378 20.125 6.875 19.622 6.875 19C6.875 18.378 7.378 17.875 8 17.875Z",
      fill: rest.fill ?? "currentColor"
    }
  ) });
};
export {
  TabletIcon
};
